import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRecipientPremiumEcardView = loadable(
  () => import(/* webpackChunkName: "content/card/recipientpremiumecardpreview" */ './RecipientPremiumEcardView'),
  'RecipientPremiumEcardView',
);
